"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var Localize_1 = require("../../gen-src/Localize");
var Icons_1 = require("../icons/Icons");
var BrowserDetection_1 = require("../utils/BrowserDetection");
var Declarative_1 = require("../utils/Declarative");
var ActivitySpinnerSize;
(function (ActivitySpinnerSize) {
    ActivitySpinnerSize[ActivitySpinnerSize["Large"] = 50] = "Large";
    ActivitySpinnerSize[ActivitySpinnerSize["Small"] = 14] = "Small";
})(ActivitySpinnerSize = exports.ActivitySpinnerSize || (exports.ActivitySpinnerSize = {}));
var getSpinnerStyle = function (spinnerSize) { return ({
    height: spinnerSize,
    width: spinnerSize,
}); };
var UnderlayStyle = {
    alignItems: 'center',
    background: 'rgba(255,255,255,.6)',
    borderRadius: 10,
    boxSizing: 'border-box',
    display: 'inline-flex',
    height: 65,
    justifyContent: 'center',
    width: 65,
};
// tslint:disable:max-line-length
var generateSvg = function (color) { return "\n  <svg viewBox=\"0 0 50 50\" style=\"cursor:wait;overflow:hidden;-webkit-animation:svg-spinner-animation 1s linear infinite;animation:svg-spinner-animation 1s linear infinite;transform-origin:center;\" xmlns=\"http://www.w3.org/2000/svg\">\n    <style>\n      @-webkit-keyframes svg-spinner-animation{100%{-webkit-transform:rotate(360deg);}}\n      @keyframes svg-spinner-animation{100%{transform:rotate(360deg);}}\n      #tail { fill: url(#fade) }\n      #head { fill: " + color + " }\n      stop { stop-color: " + color + " }\n    </style>\n    <linearGradient id=\"fade\" x2=\"50\" y1=\"25\" y2=\"25\" gradientUnits=\"userSpaceOnUse\">\n      <stop offset=\"0\" stop-opacity=\"0\"/>\n      <stop offset=\".15\" stop-opacity=\".04\"/>\n      <stop offset=\".3\" stop-opacity=\".16\"/>\n      <stop offset=\".45\" stop-opacity=\".36\"/>\n      <stop offset=\".61\" stop-opacity=\".64\"/>\n      <stop offset=\".76\"/>\n    </linearGradient>\n    <path id=\"head\" d=\"M0 25a25 25 0 1 0 50 0h-3.9a21.1 21.1 0 1 1-42.2 0\" />\n    <path id=\"tail\" d=\"M50 25a25 25 0 0 0-50 0h3.9a21.1 21.1 0 1 1 42.2 0\" />\n  </svg>\n"; };
// tslint:enable:max-line-length
var SpinnerDarkColor = 'rgb(97, 101, 112)';
var SpinnerLightColor = 'rgba(255, 255, 255, 0.8)';
/**
 * An inline activity spinner.
 *
 * NOTE: A DOM ancestor of the ActivitySpinnerWidget should have `aria-busy=true`
 */
var ActivitySpinnerWidget = /** @class */ (function (_super) {
    tslib_1.__extends(ActivitySpinnerWidget, _super);
    function ActivitySpinnerWidget() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ActivitySpinnerWidget.prototype.render = function () {
        if (this.props.shouldShowUnderlay && this.props.spinnerSize !== ActivitySpinnerSize.Large) {
            throw new Error("Underlay is only supported for Large size.");
        }
        return this.props.shouldShowUnderlay ? this.renderSpinnerWithUnderlay() : this.renderSpinner();
    };
    ActivitySpinnerWidget.prototype.renderSpinnerWithUnderlay = function () {
        return (React.createElement("div", { "data-tb-test-id": Declarative_1.testId(this.props.testId, 'Spinner-Underlay'), style: UnderlayStyle }, this.renderSpinner()));
    };
    ActivitySpinnerWidget.prototype.renderSpinner = function () {
        var style = getSpinnerStyle(this.props.spinnerSize);
        // For SVG, Edge currently doesn't support being placed in an object.
        // Because of this we place it in an iframe with scrolling='no' and frameBorder='0'.
        var color = this.props.onDarkBackground ? SpinnerLightColor : SpinnerDarkColor;
        return (BrowserDetection_1.isEdge ?
            React.createElement("iframe", { "aria-label": Localize_1.Messages.waitIndicatorLabel(), "data-tb-test-id": Declarative_1.testId(this.props.testId, 'Spinner'), frameBorder: 0, role: 'img', scrolling: 'no', src: Icons_1.encodeSvg(generateSvg(color)), style: style }) :
            React.createElement("object", { "aria-label": Localize_1.Messages.waitIndicatorLabel(), "data-tb-test-id": Declarative_1.testId(this.props.testId, 'Spinner'), data: Icons_1.encodeSvg(generateSvg(color)), role: 'img', style: style, type: 'image/svg+xml' }));
    };
    ActivitySpinnerWidget.defaultProps = {
        onDarkBackground: false,
        shouldShowUnderlay: false,
        spinnerSize: ActivitySpinnerSize.Large,
    };
    return ActivitySpinnerWidget;
}(React.Component));
exports.ActivitySpinnerWidget = ActivitySpinnerWidget;
//# sourceMappingURL=ActivitySpinnerWidget.js.map